import {
  pointsToDollars,
  dollarsToPoints,
} from '@wix/da-shared-react/pkg/utils/points';
import { InitAdapter, SubmitAdapter } from '../../types';
import { isPcpDirty } from '../../utils/form';

export function useInitAdapter(): InitAdapter {
  const DEFAULT_PRICE_POINTS = 400;

  return ({ pcp }) => {
    const downloadPrice = pcp?.downloadPrice || DEFAULT_PRICE_POINTS;
    const downloadDollarPrice =
      pcp?.downloadDollarPrice ||
      (downloadPrice ? parseFloat(pointsToDollars(downloadPrice)) : 0);

    return downloadDollarPrice;
  };
}

export const submitAdapter: SubmitAdapter = (
  { downloadDollarPrice = 0, showAttachments },
  formState
) => ({
  pcp_price_points:
    !isPcpDirty(formState) || showAttachments === false
      ? undefined
      : dollarsToPoints(downloadDollarPrice),
});

/**
 *
 */
export const cleanSubmitAdapter: SubmitAdapter = ({
  downloadDollarPrice = 0,
  showAttachments,
}) => ({
  pcp_price_points:
    showAttachments === false
      ? undefined
      : dollarsToPoints(downloadDollarPrice),
});
